<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Dedication" role="doc-dedication">
<p class="ded1"><span aria-label="page 3" id="page_3" role="doc-pagebreak">To the silent sufferers who need guidance, treatment, and good old TLC to face and hopefully conquer the nasty poop-related issues that plague them every day.</span></p>
<p class="ded2">—Susan Wong, aka Nurse Wong</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a05976fe